import React from 'react';

import styles from './Menu.module.css';

// 빈 밀박스/부페 메뉴 
const EmptyMealBox = ({ menu, onDropMenu }) => {

  return (
    <div
      className={styles.menu}
      onDragEnter={evt => { evt.preventDefault(); }}
      onDragOver={evt => { evt.preventDefault(); }}
      onDrop={onDropMenu}
      data-date={menu.date}
      data-servicetime={menu.serviceTime}
      data-menutype={menu.menuType}
    >
      <div className={`${styles.supplierTitle} ${styles.noData}`}>
        메뉴가 없습니다 
      </div>
      <div className={styles.description}>
        큐레이션 실행 버튼을 누르거나, 메뉴를 드래그하여 배치해주세요. 메뉴가 없다면 메뉴가 제공되지 않습니다.
      </div>
    </div>
  );
}

export default EmptyMealBox;